$shm_hitalama_map_widget_float_component_parser $shm_hitalama_map_widget_float_code
	textarea_hint \typescript
	run null
